import type { FlightLeg } from "./types";

/** Row shape from Supabase `flight_legs`. */
export type FlightLegRow = {
  id: string;
  flight_date: string;
  aircraft: string;
  from_icao: string;
  to_icao: string;
  route_notes: string;
  tach_start: number | null;
  tach_end: number | null;
  flight_hours: number | null;
  fuel_lbs: number | null;
  fuel_gal: number | null;
  fuel_price_per_gallon: number | null;
  takeoffs: number | null;
  landings: number | null;
  texas_arrival: boolean;
  passenger_count: number;
  passengers: string | null;
  crew: string | null;
  segments_domestic: number;
  dom_pax: number | null;
  intl_pax: number;
  akhi_pax: number;
  charter_usd: number;
  rural_exempt: boolean;
  personal_use: boolean;
  exclude_from_720: boolean;
  departure_state: string | null;
};

export function flightLegRowToLeg(r: FlightLegRow): FlightLeg {
  return {
    id: r.id,
    flightDate: r.flight_date,
    aircraftId: r.aircraft,
    fromIcao: r.from_icao,
    toIcao: r.to_icao,
    routeNotes: r.route_notes ?? "",
    tachStart: r.tach_start,
    tachEnd: r.tach_end,
    flightHours: r.flight_hours,
    fuelLbs: r.fuel_lbs,
    fuelGallonsReported: r.fuel_gal,
    fuelPricePerGallon: r.fuel_price_per_gallon,
    takeoffs: r.takeoffs,
    landings: r.landings,
    texasArrival: Boolean(r.texas_arrival),
    passengerCount: r.passenger_count,
    passengerList: r.passengers,
    crewList: r.crew ?? null,
    segmentsDomestic: r.segments_domestic,
    passengersDomesticSegmentTax: r.dom_pax,
    internationalFacilityPassengers: r.intl_pax,
    alaskaHawaiiDomesticDeparturePassengers: r.akhi_pax,
    charterOrFareAmountUsd: r.charter_usd,
    ruralAirportExempt: r.rural_exempt,
    personalUse: r.personal_use,
    excludeFrom720: r.exclude_from_720,
    departureState: r.departure_state,
  };
}

export function flightLegToRow(leg: FlightLeg): Omit<FlightLegRow, "id"> & { id?: string } {
  const row: Omit<FlightLegRow, "id"> & { id?: string } = {
    flight_date: leg.flightDate,
    aircraft: leg.aircraftId || "N426DH",
    from_icao: leg.fromIcao,
    to_icao: leg.toIcao,
    route_notes: leg.routeNotes ?? "",
    tach_start: leg.tachStart ?? null,
    tach_end: leg.tachEnd ?? null,
    flight_hours: leg.flightHours ?? null,
    fuel_lbs: leg.fuelLbs,
    fuel_gal: leg.fuelGallonsReported,
    fuel_price_per_gallon: leg.fuelPricePerGallon ?? null,
    takeoffs: leg.takeoffs,
    landings: leg.landings,
    texas_arrival: Boolean(leg.texasArrival),
    passenger_count: leg.passengerCount,
    passengers: leg.passengerList ?? null,
    crew: leg.crewList ?? null,
    segments_domestic: leg.segmentsDomestic,
    dom_pax: leg.passengersDomesticSegmentTax,
    intl_pax: leg.internationalFacilityPassengers,
    akhi_pax: leg.alaskaHawaiiDomesticDeparturePassengers,
    charter_usd: leg.charterOrFareAmountUsd,
    rural_exempt: leg.ruralAirportExempt,
    personal_use: leg.personalUse,
    exclude_from_720: leg.excludeFrom720,
    departure_state: leg.departureState,
  };
  if (leg.id) row.id = leg.id;
  return row;
}
